import { Injectable, inject } from '@angular/core';
import { DataChangeWatcherService } from 'mbs-ui-kit';
import { Observable } from 'rxjs';

@Injectable()
export class DataChangeWatcherGuard {
  private dcw = inject(DataChangeWatcherService);

  canDeactivate(): Observable<boolean> {
    return this.dcw.detectChanges();
  }
}
